<!-- eslint-disable max-lines -->
<template>
    <div class='vehicleFreePlatformList'>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :currentPage="currentPage"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="vehicleFreePlatformQuery"
            pageID="vehicleFreePlatform"
            @edit-btn="editBtn"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn">
                 <reportExport #default="{ submit }" reportCode="REPORT_OTP_ROAD_SONG">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp04080003'">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="againClick">重新推送</el-button>
            </div>
        </m-pane>
        <push-log-dialog
            v-if="visiableDialog"
            :label-position="labelPosition"
            :visiableDialog.sync="visiableDialog"
            @handleClose="handleClose"
            :dataLists='dataObj'
            @addOk="addOk"
        ></push-log-dialog>
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.js';
import pushLogDialog from '../../../../components/dialog/pushLogDialog';
import reportExport from '@/components/lots/reportExportPlugin';
import { getLists, getAgainLists, getUpdateLists } from '../../../../api/vehicleFreePlatform';
import formatTime from '@/utils/common.js';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { mPane, pushLogDialog, reportExport },
    data() {
        return {
            selected: [],
            searchDataLists: {
                pageNo: 1,
                pageSize: 10,
                noCarCarrierType: '10'
            },
            dataObj: {},
            selectData: [],
            currentPage: 1,
            pageTotal: 0,
            totalData: [],
            loading: false,
            config,
            labelPosition: 'right',
            visiableDialog: false,
            activeName: 'first',
            isFirstSearch: true
        };
    },
    methods: {
        async load() {
            this.currentPage = this.searchDataLists.pageNo;
            const startTime = this.searchDataLists.beginDate || 0;
            const endTime = this.searchDataLists.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!this.searchDataLists.dispatchNo && !startTime) {
                return this.$message.warning('发车单号 和 创建时间 不可同时为空');
            } else if (!this.searchDataLists.dispatchNo && startTime) {
                if (timeDifference > 63 * 24 * 60 * 60 * 1000) {
                    return this.$message.warning('按时间查询时，查询时间跨度不可超过两个月！');
                }
            }
            this.loading = true;
            // const statusMap = new Map();
            const resultMap = new Map();
            // statusMap.set('SUCCESS', '成功').set('FAIL', '失败');
            resultMap.set('0', '成功').set('1', '失败');
            const dict = await dictWithUrl('S_F_FLAG');
            const dictData = dict.data;
            getLists(this.searchDataLists).then(res => {
                this.totalData = res.data.list.map(item => {
                    // item.statusText = statusMap.get(item.status);
                    item.statusText = dictData.S_F_FLAG[item.status] || item.status;
                    item.resultText = resultMap.get(item.result);
                    return item;
                });
                this.totalData.forEach((item, index) => {
                    switch (item.status) {
                    case 'SUCCESS':
                        item.hiddenEvent = [ 'edit' ];
                        break;
                    }
                });
                this.pageTotal = res.data.totalCount;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        againClick() {
            if (this.selected.length === 0) {
                this.$message.warning('至少选择一条数据');
                return;
            } else if (this.selected.length > 20) {
                this.$message.warning('最多只能选择20条数据');
                return;
            }
            for (let index = 0; index < this.selected.length; index++) {
                if (this.selected[index].status === 'SUCCESS') {
                    this.$message.warning('成功状态下不能再次推送');
                    return;
                }
            }
            const arr = [];
            this.selected.forEach(item => {
                arr.push({ dispatchNo: item.dispatchNo, status: item.status });
            });
            getAgainLists(arr).then(res => {
                if (res.code === '0') {
                    this.$message.success('重新推送成功');
                }
                this.load();
            });
        },
        editBtn(data) {
            this.dataObj = data;
            this.dispatchNo = data.dispatchNo;
            this.visiableDialog = true;
        },
        handleClose() {
            this.visiableDialog = false;
        },
        addOk(formName) {
            const dispatchNo = this.dispatchNo;
            formName.data['dispatchNo'] = dispatchNo;
            if (formName.state === true) {
                getUpdateLists(formName.data, this.dispatchNo).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('编辑成功');
                        this.load();
                    }
                });
            } else {
                return false;
            }
        },
        pageChange(data) {
            this.searchDataLists.pageNo = data;
            this.load();
        },
        sizeChange(data) {
            this.searchDataLists.pageSize = data;
            this.searchDataLists.pageNo = 1;
            this.load();
        },
        searchChange(data) {
            this.isFirstSearch = false;
            if (data.createTime !== null && data.createTime !== '') {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else {
                data.beginDate = '';
                data.endDate = '';
            };
            this.dispatchNo = data.dispatchNo;
            this.status = data.status;
            this.siteCode = data.siteCode;
            delete data.createTime;
            this.searchDataLists = {
                ...this.searchDataLists,
                ...data,
                pageNo: 1
            };
            this.load();
        },
        selectChange(data) {
            data.forEach(item => {
                this.dispatchNo = item.dispatchNo;
            });
            this.selected = [].concat(data);
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchDataLists,
                tenantCode: 'BLANK'
            });
        }
    }
};
</script>

<style lang="less">
.vehicleFreePlatformList {
    .text-color {
        text-align: center;
        width: 50px;
        display: inline-block;
    }
    .el-tabs__item {
        height: 28px !important;
        line-height: 28px !important;
    }
    .el-tabs__header {
        margin: 0 0 10px;
    }
}
</style>
